import { useMutation, useQueryClient } from '@tanstack/react-query';

import { configs } from '@hero/configs';
import { QUERY_KEYS } from '@hero/constants';
import { recognitionServices } from '@hero/services';

export const useUpdateRecognition = ({ options: { onSuccess, ...options } = {} } = {}) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ params: { recognitionCode }, body }) => {
      // backend don't allow to onlyCollectAddressEnabled key so we add that logic for now.
      if (!configs.advanceSettings.onlyCollectAddressEnabled) {
        delete body?.settings?.onlyCollectAddressEnabled;
      }

      return recognitionServices.update(recognitionCode, body);
    },
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.useGetRecognitionsKey]
        });
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.useGetRecognitionKey, variables.params.recognitionCode]
        });
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.useGetRecognitionsApprovalKey, variables.params.recognitionCode]
        });

        if (variables?.body?.products) {
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.useGetRecognitionProductsKey, variables.params.recognitionCode]
          });
        }

        const canAskForSpendingSummary = variables?.body?.contacts || variables?.body?.products;

        if (canAskForSpendingSummary) {
          queryClient.invalidateQueries({
            queryKey: ['recognitionSpendingSummary', variables.params.recognitionCode],
            refetchType: 'active'
          });
        }

        if (onSuccess) onSuccess(data, variables);
      },
      ...options
    }
  );
};
